// 导入必要的类型和工具
import { GetDemandsType } from "@/interface";
import useConnectWallet from "@/store/wallet/useConnectWallet";
import { formatUnits } from "ethers";
import { useCallback, useEffect, useState } from "react";

// 每次获取数据的条数限制
const limit = 20;

// 自定义 Hook，用于分页获取需求数据
const useGetDemandsByLimit = () => {
    // 获取钱包地址和合约实例
    const { contractEvm: { FlexibleStaking }, address } = useConnectWallet();
    // 定义状态变量
    const [data, setData] = useState<GetDemandsType[]>([]); // 需求数据
    const [getDemandsLod, setLoading] = useState(false); // 加载状态
    const [start, setStart] = useState("1000000000000000000"); // 分页起始点
    const [end, setEnd] = useState(false); // 分页结束点
    const [ready, setReady] = useState(false); // 标记状态设置完毕

    // 获取需求数据的函数
    const getDemandsByLimit = useCallback(async () => {

        if (FlexibleStaking) {
            try {
                setLoading(true);
                // 调用合约方法获取数据
                const res = await FlexibleStaking.getDemandsByLimit(address, start, limit);
                setEnd(res.length < limit);
                // 如果返回数据不为空，更新分页起始点
                if (res.length) {
                    const id = Number(formatUnits(res[res.length - 1].id, 0)) - 1 || 0;
                    if (id <= 0) {
                        setStart('0');
                    } else {
                        setStart(id.toString());
                    }
                    // 将新数据追加到需求数据中
                    setData([...data, ...res]);
                } else {
                    setStart('0');
                }
            } catch (error) {
                console.log('useGetDemands', error);
            } finally {
                setLoading(false);
            }
        }
    }, [FlexibleStaking, address, data, start]);

    // 第一步：初始化状态
    useEffect(() => {
        if (FlexibleStaking) {
            setData([]);
            setStart('1000000000000000000');
            setEnd(false);
            setReady(true);
        }
    }, [FlexibleStaking]);

    // 第二步：当状态设置完后执行请求
    useEffect(() => {

        if (ready) {
            getDemandsByLimit();
            setReady(false);
        }
    }, [getDemandsByLimit, ready]);

    // 返回 Hook 的方法和状态
    return { getDemandsByLimit, data, getDemandsLod, end };
};

// 导出自定义 Hook
export default useGetDemandsByLimit;